<div class="section-container" id="education">
  <div class="section-left">
    <h2>{{strings.education}}</h2>
  </div>

  <div class="section-right">
    <div class="education-section-wrapper">
      <div class="section-title">
        <h2 [innerHTML]="strings.educationSectionTitle"></h2>
        <div class="education-card">
          <div class="bulletpoint"></div>
          <div class="education-card-title-wrapper">
            <h1>{{strings.aubihTitle}}</h1>
            <p>{{strings.aubihSubtitle}}</p>
          </div>
        </div>
        <div class="education-card">
          <div class="bulletpoint"></div>
          <div class="education-card-title-wrapper">
            <h1>{{strings.mssTitle}}</h1>
            <p>{{strings.mssSubtitle}}</p>
          </div>
        </div>
      </div>
      <div class="education-section-content">
        <img src="assets/education.webp" alt="Book" loading="lazy">
      </div>
    </div>
  </div>
</div>

